module.exports = window["wp"]["blockDirectory"];